class enjpWishlist extends HTMLElement {
  constructor() {
    super();
    this.customerId = ShopifyAnalytics.meta.page.customerId || null;
    this.wishlistData = {
      items: [],
      count: 0,
    };
  }
  connectedCallback() {
    this.loadWishlist();
    window.addEventListener('pageshow', (event) => {
      if (event.persisted || performance.getEntriesByType("navigation")[0].type === "back_forward") {
        this.loadWishlist();
      }
    });
  }

  getWishlistId() {
    var cookies = decodeURIComponent(document.cookie).split(';');

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();

      if (cookie.indexOf('wishlist_id=') === 0) {
        return cookie.substring('wishlist_id='.length);
      }
    }

    return null;
  }

  loadWishlist() {
    let urlToFetch;
    if (this.customerId) {
      urlToFetch = '/a/wishlist?type=api&customerid=' + this.customerId + '&version=1';
    } else {
      urlToFetch = '/a/wishlist?type=api&wishlistid=' + this.getWishlistId() + '&version=1';
    }

    fetch(urlToFetch, { cache: 'no-store' }).
      then(response => response.text()).
      then(
        (data) => {
          this.wishlistData = JSON.parse(data);
          this.loadWishlistItems();
          this.updateAllCounters();
          const event = new CustomEvent('wishlist-loaded', {
            detail: this.wishlistData
          });
          document.dispatchEvent(event);
        }
      ).catch(err => console.log('Error while fetching wishlist:', err));

  }
  initWishEmptyOrNot() {
    const emptyState = document.querySelector('#wishlist-empty');

    if (!this.wishlistData.items.length) {
      if (emptyState) emptyState.style.display = 'block';
      return;
    } else {
      if (emptyState) emptyState.style.display = 'none';
    }
  }
  async loadWishlistItems() {
    const wrapper = document.querySelector('#wishlist-products-wrapper');
    this.initWishEmptyOrNot();
    // Filtra per handle unici
    const uniqueItemsByHandle = [];
    const seenHandles = new Set();

    for (const item of this.wishlistData.items) {
      if (!seenHandles.has(item.handle)) {
        seenHandles.add(item.handle);
        uniqueItemsByHandle.push(item);
      }
    }

    const fetchArray = uniqueItemsByHandle.map(item =>
      fetch(`${Shopify.routes.root}products/${item.handle}/?sections=enjp-wishlist-item`)
        .then(res => res.json())
        .then(data => data['enjp-wishlist-item'])
    );
    if (this.isWishlistPage()) {
      try {
        const productCards = await Promise.all(fetchArray);
        // Inserisci le card nel DOM
        wrapper.innerHTML = productCards.join('');
      } catch (error) {
        console.error("Errore nel caricamento dei prodotti wishlist:", error);
      }
    }
  }
  isWishlistPage() {
    return document.getElementById('wishlist-products-wrapper') !== null;
  }
  removeItem(wishlistItem) {
    try {
      const { productId, variantId } = wishlistItem.dataset;
      if (!productId || !variantId) throw new Error('Missing Dataset');

      if (typeof RemoveFromSmartWishlist === 'function') {
        RemoveFromSmartWishlist(productId, variantId);
      }

      this.removeItemFromWishlistData(productId, variantId, this.customerId);

      // Remove bookmarked class from wishlist button
      this.updateWishlistButtonBookmarkState(productId, variantId, false);

      if (this.isWishlistPage()) {
        const cardId = `wishlist-card-${productId}-${variantId}`;
        const cardToRemove = document.getElementById(cardId);
        if (cardToRemove) {
          cardToRemove.closest(".shopify-section").remove();
          this.initWishEmptyOrNot();
        }
      }

      this.updateAllCounters();

    } catch (err) {
      console.error('error removing element', err);
    }
  }

  removeItemFromWishlistData(productId, variantId) {
    this.wishlistData.items = this.wishlistData.items.filter(item =>
      !(String(item.id) === String(productId) && String(item.variant_id) === String(variantId))
    );
    this.wishlistData.count = this.wishlistData.items.length;
  }

  addItem(wishlistItem) {
    try {
      const { productId, variantId } = wishlistItem.dataset;
      if (!productId || !variantId) throw new Error('Missing Dataset');

      if (typeof AddToSmartWishlist === 'function') {
        AddToSmartWishlist(productId, variantId, this.customerId);
      }

      // update internal data
      this.wishlistData.items.push({
        id: productId,
        variant_id: variantId,
        handle: wishlistItem.handle
      });

      this.wishlistData.count = this.wishlistData.items.length;

      // Add bookmarked class to wishlist button
      this.updateWishlistButtonBookmarkState(productId, variantId, true);

      this.updateAllCounters();

    } catch (err) {
      console.error('Error by adding item:', err);
    }
  }

  // New method to update wishlist button bookmark state
  updateWishlistButtonBookmarkState(productId, isBookmarked) {
    const buttons = document.querySelectorAll(`enjp-wishlist-toggle-button[data-product_id="${productId}"]`);
    buttons.forEach(button => {
      if (isBookmarked) {
        button.classList.add('enjp-bookmarked');
      } else {
        button.classList.remove('enjp-bookmarked');
      }
    });
  }

  isItemInWishlist(wishlistItem) {
    if (!Array.isArray(this.wishlistData.items)) return false;

    const { productId, variantId } = wishlistItem.dataset;
    return this.wishlistData.items.some(
      (item) =>
        String(item.id) === String(productId) &&
        String(item.variant_id) === String(variantId)
    );
  }

  wishButton(wishlistItem) {
    if (this.isItemInWishlist(wishlistItem)) this.removeItem(wishlistItem);
    else this.addItem(wishlistItem);
  }
  updateAllCounters() {
    const counters = document.querySelectorAll('.elementCount');
    counters.forEach(counter => {
      counter.textContent = this.wishlistData.count;
    });
  }
}
if (customElements.get('enjp-wishlist') === undefined) {
  customElements.define('enjp-wishlist', enjpWishlist);
}

class enjpWishlistToggleButton extends HTMLElement {
  constructor() {
    super();

    this.productId = this.dataset.product_id;
    this.variantId = this.dataset.variant_id;
    this.wishlist = document.querySelector('enjp-wishlist');
    this.productCard = this.closest('product-card');
  }

  connectedCallback() {
    this.toggleAttribute('disabled', true);
    this.wishlist = document.querySelector('enjp-wishlist');

    document.addEventListener('wishlist-loaded', () => {
      this.wishlist = document.querySelector('enjp-wishlist');
      if (!this.wishlist) return;

      this.toggleAttribute('disabled', false);
      this.updateUI();
      this.updateWishlistButtonBookmarkState();
    });

    // fallback: se wishlist già pronta
    if (this.wishlist?.wishlistData?.items?.length > 0) {
      this.toggleAttribute('disabled', false);
      this.updateUI();
      this.updateWishlistButtonBookmarkState();
    }

    if (!this.productId || !this.variantId || !this.wishlist) return;

    this.addEventListener('click', () => {
      const wishlistItem = {
        dataset: {
          productId: this.productId,
          variantId: this.variantId
        },
        handle: this.dataset.handle
      };

      this.wishlist.wishButton(wishlistItem);
      this.toggleActiveState();
      this.updateUI();
      this.updateWishlistButtonBookmarkState();
    });

    // keyboard accessibility
    this.addEventListener('keydown', (event) => {
      if (document.activeElement !== this) return;
      if (event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        this.click();
      }
      if (event.key === 'Enter') {
        this.click();
      }
    });

    document.addEventListener('wishlist-updated', () => {
      this.updateUI();
      this.updateWishlistButtonBookmarkState();
    });
  }


  // New method to update wishlist button bookmark state
  updateWishlistButtonBookmarkState() {
    if (!this.wishlist) return;

    const isInWishlist = this.wishlist.isItemInWishlist({
      dataset: {
        productId: this.productId,
        variantId: this.variantId
      }
    });

    if (isInWishlist) {
      this.classList.add('enjp-bookmarked');
    } else {
      this.classList.remove('enjp-bookmarked');
    }
  }

  //update the ui button (the button to remove in pdp is different) by adding fill and edit the tooltip text 
  updateUI() {
    const svg = this.querySelector('svg');
    this.wishlist = document.querySelector('enjp-wishlist');

    if (!svg || !this.wishlist) return;

    const isInWishlist = this.wishlist.isItemInWishlist({
      dataset: {
        productId: this.productId,
        variantId: this.variantId
      }
    });

    if (isInWishlist) {
      svg.classList.add('tw-fill-black');
      this.classList.add('wishlist-active');
    } else {
      svg.classList.remove('tw-fill-black');
      this.classList.remove('wishlist-active');
    }

    const tooltip = this.closest('div')?.querySelector('.tooltip');
    if (tooltip) {
      const tooltipAdd = tooltip.querySelector('.tooltip-add');
      const tooltipRemove = tooltip.querySelector('.tooltip-remove');
      if (tooltipAdd) tooltipAdd.classList.toggle('tw-hidden', isInWishlist);
      if (tooltipRemove) tooltipRemove.classList.toggle('tw-hidden', !isInWishlist);
    }
  }

  toggleActiveState() {
    const svg = this.querySelector('svg');
    if (svg) {
      svg.classList.toggle('tw-fill-black');
      this.classList.toggle('wishlist-active');
    }
  }
}

if (customElements.get('enjp-wishlist-toggle-button') === undefined) {
  customElements.define('enjp-wishlist-toggle-button', enjpWishlistToggleButton);
}
class enjpWishlistActionButton extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.product_id;
    this.variantId = this.dataset.variant_id;
    this.handle = this.dataset.handle;
    this.wishlist = document.querySelector('enjp-wishlist');
  }

  connectedCallback() {
    if (!this.productId || !this.wishlist) return;

    this.button = this.querySelector('[data-wishlist]');
    this.textAdd = this.querySelector('[data-wishlist-add]');
    this.textRemove = this.querySelector('[data-wishlist-remove]');

    this.updateUI();

    this.button.addEventListener('click', () => {
      const wishlistItem = {
        dataset: {
          productId: this.productId,
          variantId: this.variantId
        },
        handle: this.handle
      };

      this.wishlist.wishButton(wishlistItem);
      this.updateUI();
    });

    document.addEventListener('wishlist-updated', () => this.updateUI());
    document.addEventListener('wishlist-loaded', () => this.updateUI());
  }

  updateUI() {
    const isInWishlist = this.wishlist?.isItemInWishlist({
      dataset: {
        productId: this.productId,
        variantId: this.variantId
      }
    });

    if (isInWishlist) {
      this.textAdd?.classList.add('tw-hidden');
      this.textRemove?.classList.remove('tw-hidden');
      this.button?.classList.add('enjp-bookmarked');
    } else {
      this.textAdd?.classList.remove('tw-hidden');
      this.textRemove?.classList.add('tw-hidden');
      this.button?.classList.remove('enjp-bookmarked');
    }
  }
}
if (customElements.get('enjp-wishlist-action-button') === undefined) {
  customElements.define('enjp-wishlist-action-button', enjpWishlistActionButton);
}